import { useInfiniteQuery } from 'react-query';
import { Waypoint } from 'react-waypoint';

import { ActivityService } from 'src/services';
import { BackLink, Header, SessionCard } from 'src/components';
import { arrayOfNumbers } from 'src/utils/array';

import { List, Item } from './styles';

const itemsPerPage = 6;

export const Likes: React.FC = () => {
  const query = useInfiniteQuery(
    'likes',
    fetchLikes,
    {
      getNextPageParam: ({page, pageCount}) => page < pageCount ? page : false,
      refetchOnWindowFocus: false,
    },
  );

  const items = query.data?.pages.flatMap(page => page.data) ?? [];
  const fetchNextPage = query.hasNextPage && !query.isFetchingNextPage
    ? () => query.fetchNextPage()
    : () => {};
  const placeholderCount = (query.isFetching || query.hasNextPage) ? itemsPerPage : 0; 
  const cardsCount = items.length + placeholderCount;

  return (
    <>
      <BackLink label="Twoja praktyka" to="/me/summary" />
      <Header
        title="Ulubione"
        as="h1"
      />
      <List>
        {arrayOfNumbers(cardsCount).map(index => (
          <Item key={index}>
            {
              index > cardsCount - (itemsPerPage * 2) &&
              <Waypoint onEnter={fetchNextPage} />
            }
            <SessionCard
              mode="horizontal"
              session={items[index]}
              order={index % itemsPerPage}
              backNavigationInfo={{
                link: '/likes',
                linkLabel: 'Ulubione',
              }}
            />
          </Item>
        ))}
      </List>
    </>
  );
};

const fetchLikes = ({ pageParam = 0 }) =>
  ActivityService.getLikedSessionsAndChallenges(pageParam + 1, itemsPerPage);
